export enum FileStatus {
  Online = "Online",
  Offline = "Offline",
  Recording = "Recording",
  Broken = "Broken",
  Deleted = "Deleted",
}
